// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__QfTV6","legal":"Footer_legal__YIebs","form":"Footer_form__P1da_","title":"Footer_title__lArUt"};